module.exports = __webpack_public_path__ + "static/img/supersign-hd-bg.423a14a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/supersign-hd-bg.png
// module id = QcSG
// module chunks = 1